import {
    ACCOUNT_PASSWORD,
    ACCOUNT_PROFILE,
    COMMUNITY_ANALYSES,
    COMMUNITY_LOBBY,
    BETBOOK_TICKETS,
    BONUS_DASHBOARD_CURRENT,
    BONUS_DASHBOARD_HISTORY,
    CASINO_GAME,
    CASINO_GAME_ENDED,
    CASINO_GAME_HRY_CATEGORY,
    CASINO_GAME_KASINO_CATEGORY,
    CASINO_LOBBY,
    COMMUNITY_CHAT,
    CONTACT_US,
    CONTACT_US_INFO,
    MONEY_DEPOSIT,
    MONEY_TRANSFER,
    MONEY_WITHDRAWAL,
    MY_TICKETS,
    NIKE1,
    NOTIFIED_MATCHES,
    NOTIFIED_TICKETS,
    OFFICES,
    SAVED_TICKETS,
    SCRATCHCARD_I_SCRATCH_PLAY,
    TICKET_DETAIL,
    TICKET_DETAIL_ALIAS,
    TURBO_LIVE_FAVORITES,
    TURBO_LIVE_SPORT,
    VIRTUAL_GAMES
} from './routes';

export const getCasinouRoutes = () => [CASINO_LOBBY, CASINO_GAME_KASINO_CATEGORY, CASINO_GAME_HRY_CATEGORY];
export const getCommunityRoutes = () => [COMMUNITY_LOBBY, COMMUNITY_ANALYSES, BETBOOK_TICKETS, COMMUNITY_CHAT];
export const getOfferRouter = () => [NIKE1, VIRTUAL_GAMES, TURBO_LIVE_SPORT, TURBO_LIVE_FAVORITES];
export const getTicketRoutes = () => [MY_TICKETS, SAVED_TICKETS, TICKET_DETAIL, TICKET_DETAIL_ALIAS];

const getSameNavigationRouteGroups = () => [
    [MONEY_WITHDRAWAL, MONEY_DEPOSIT, MONEY_TRANSFER],

    [CONTACT_US, CONTACT_US_INFO, OFFICES],

    [BONUS_DASHBOARD_CURRENT, BONUS_DASHBOARD_HISTORY],

    [ACCOUNT_PROFILE, ACCOUNT_PASSWORD],

    [NOTIFIED_MATCHES, NOTIFIED_TICKETS]
];

export const getSpecialLayoutRoutes = () => [CASINO_GAME, CASINO_GAME_ENDED, SCRATCHCARD_I_SCRATCH_PLAY];

export function isInSameNavigationGroup(current, target) {
    if (current === target) {
        return true;
    }
    for (const group of getSameNavigationRouteGroups()) {
        let hasCurrent = false;
        let hasTarget = false;
        for (const route of group) {
            if (route === current) {
                hasCurrent = true;
            }
            if (route === target) {
                hasTarget = true;
            }
        }
        if (hasCurrent && hasTarget) {
            return true;
        }
    }
    return false;
}
